<template>
  <v-main>
    <v-container>
      <Navbar />
    </v-container>
    <v-container fluid class="pt-10" style="max-width:1800px">
      <router-view />
    </v-container>
    <!-- <v-snackbar
      v-for="(snackbar, index) in snackbar.snackbars.filter((s) => s.showing)"
      :key="snackbar.text + Math.random()"
      v-model="snackbar.showing"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      right
      bottom
      tile
      :style="`transform: translateY(-${index * 60 + 8}px); `"
      transition="fade-transition"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" right @click="snackbar.showing = false" text>
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar> -->
  </v-main>
</template>

<script>
import Vue from "vue";
import Navbar from "@/components/Dashboard/Navbar.vue";
import { mapActions, mapState } from "vuex";
// import { StatusService } from "@/common/services";

export default Vue.extend({
  name: "Dashboard",
  components: {
    Navbar,
  },
  computed: {
    ...mapState(["snackbar"]),
  },
  methods: {
    ...mapActions(["isAdmin"]),
    // async getInfo() {
    //   console.log(StatusService);
    //   try {
    //     const { data } = await StatusService.get();
    //     console.log(data.data);
    //   } catch (error) {
    //     console.log("jakis blad", error);
    //   }
    // },
  },
  mounted() {
    // this.getInfo();
  },
});
</script>
<style lang="scss">
a {
  text-decoration: none;
}
</style>
